import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Reveal = ({ children, className = "", delay = 0, y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const ChapterHeading = ({ number, eyebrow, title, dark = false }) => (
  <div className="flex items-start gap-5 md:gap-8">
    <span
      aria-hidden="true"
      className={`font-heading text-7xl md:text-8xl font-extrabold leading-none select-none ${
        dark ? "outline-numeral-dark" : "outline-numeral"
      }`}
    >
      {number}
    </span>
    <div className="pt-2 md:pt-4">
      <p className={`eyebrow ${dark ? "!text-azure" : ""}`} data-testid={`chapter-${number}-eyebrow`}>
        {eyebrow}
      </p>
      <h2
        className={`mt-3 text-lg font-extrabold tracking-tight md:text-xl ${
          dark ? "text-white" : "text-ink"
        }`}
      >
        {title}
      </h2>
    </div>
  </div>
);
